export const LISTING_PAGE_SIZE = 12;

import type { VillageViewModel, IntervieweeCard } from "../domain/contracts";

export function filterVillage(village: VillageViewModel, query: string): boolean {
  const haystack = `${village.title} ${village.township}`.toLowerCase();
  return haystack.includes(query);
}

export function filterInterviewee(item: IntervieweeCard, query: string): boolean {
  const haystack = `${item.publicPseudonym} ${item.currentContext ?? ""} ${item.displacementYear ?? ""}`.toLowerCase();
  return haystack.includes(query);
}
